// ============================================================
// MÉGAMENU AU SURVOL — Bijouterie Suisse
// Ouvre le mégamenu Dawn au survol (desktop only)
// Conserve le comportement clic sur mobile
// ============================================================

(function() {
  'use strict';

  const MOBILE_BREAKPOINT = 990; // Dawn passe en mobile en dessous
  const CLOSE_DELAY = 150; // Délai avant fermeture (ms) pour éviter les flickers

  // Vérifier si on est sur desktop
  function isDesktop() {
    return window.innerWidth >= MOBILE_BREAKPOINT;
  }

  // Initialisation
  function init() {
    // On cible les <details> de la classe mega-menu (les vrais menus déroulants Dawn)
    const detailsElements = document.querySelectorAll('details.mega-menu');
    
    if (detailsElements.length === 0) {
      console.log('[MegaMenuHover] Aucun mégamenu trouvé');
      return;
    }

    console.log(`[MegaMenuHover] Initialisé sur ${detailsElements.length} mégamenu(s)`);

    detailsElements.forEach(function(detailsEl) {
      // Le <li> parent qui contient tout
      const liParent = detailsEl.closest('li');
      if (!liParent) return;

      let closeTimer = null;

      // Ouvrir au survol du <li>
      liParent.addEventListener('mouseenter', function() {
        if (!isDesktop()) return; // Ignorer sur mobile
        clearTimeout(closeTimer);
        detailsEl.setAttribute('open', '');
      });

      // Fermer quand la souris sort (avec petit délai)
      liParent.addEventListener('mouseleave', function() {
        if (!isDesktop()) return;
        closeTimer = setTimeout(function() {
          detailsEl.removeAttribute('open');
        }, CLOSE_DELAY);
      });

      // Empêcher le clic d'ouvrir/fermer quand on est en mode hover
      const summary = detailsEl.querySelector('summary');
      if (summary) {
        summary.addEventListener('click', function(e) {
          if (!isDesktop()) return; // Garder clic mobile normal
          e.preventDefault();
        });
      }
    });
  }

  // Démarrer après chargement du DOM
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();